export enum TipoUsuario{
  portal = '1',
  funcionarioRh = '2',
  gestorRh = '3',
  gerente = '4',
  bpo = '5',
}

